import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import zh from './zh'
import ar from './ar'
import indonesian from './indonesian'
import vi from './vi'



// 注册插件
Vue.use(VueI18n)

// 实例化
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh', // 默认语言
  fallbackLocale: 'en', // 语言切换失败时的备用语言
  messages: {
    en,
    zh,
    ar,
    indonesian,
    vi
  }
})

export default i18n